import {Component, OnInit} from '@angular/core';
import {CollectionsService} from '../../service/collections.service';
import {Subscription} from 'rxjs';
import i18next from "i18next";

@Component({
  selector: 'app-collections-list',
  templateUrl: './collections-list.component.html',
  styleUrls: ['./collections-list.component.scss']
})
export class CollectionsListComponent implements OnInit {
  collectionData: any[] | undefined;
  dataLoaded = this.collectionsService.dataLoaded;
  // DnD Horizontal scrolling
  scrollC!: any;
  isDown = false;
  startX!: number;
  scrollLeft!: number;

  private subscriptions: Subscription = new Subscription();

  constructor(public collectionsService: CollectionsService) {
    const collectionDataSub = this.collectionsService.loadDataObservable$.subscribe(() => {
      this.serveData();
    });
    this.subscriptions.add(collectionDataSub);
  }

  ngOnInit(): void {
    const has: boolean = i18next.hasResourceBundle('de', 'translations');
    console.log(has);
    if (this.dataLoaded) {
      this.serveData();
    }
    // console.log(this.collectionsService.translations);
    this.scrollC = document.querySelector('.collections-list');
    this.scrollC.addEventListener('mousedown', (e: any) => {
      this.isDown = true;
      this.startX = e.pageX - this.scrollC.offsetLeft;
      this.scrollLeft = this.scrollC.scrollLeft;
    });
    this.scrollC.addEventListener('mouseleave', () => {
      this.isDown = false;
      this.scrollC.classList.remove('active');
    });

    this.scrollC.addEventListener('mouseup', () => {
      this.isDown = false;
      this.scrollC.classList.remove('active');
    });
    this.scrollC.addEventListener('mousemove', (e: any) => {
      if (!this.isDown) {
        return;
      }
      this.scrollC.classList.add('active');

      e.preventDefault();
      const x = e.pageX - this.scrollC.offsetLeft;
      const walk = (x - this.startX);
      this.scrollC.scrollLeft = this.scrollLeft - walk;
      // console.log(walk);
    });
  }

  serveData(): void {
    // console.log(this.collectionsService.teaserData);
    this.collectionData = this.collectionsService.teaserData.sort((a, b) => {
      return a.teaser_sorting - b.teaser_sorting;
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
